import React, { useCallback, useRef } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import Paper from "@material-ui/core/Paper";
import Button from "@material-ui/core/Button";
import { useLocation } from "react-router-dom";
import FlightIcon from "../../assets/img/plane.png";
import CircularProgress from "@material-ui/core/CircularProgress";
import IconBack from "@material-ui/icons/ArrowBack";
import moment from "moment";
import { useEffect } from "react";
import axios from "axios";
import { useState } from "react";
import { useParams } from "react-router-dom";
import Swal from "sweetalert2";
import ContactDetail from "./ContactDetail";
import { connect, useDispatch, useSelector } from "react-redux";
import { toggleSignUp, getUserDetails } from "../../store/actions/user/User";
import { getVendorDetails } from "../../store/actions/vendor/Vendor";
import { saveBooking } from "../../store/actions/flights/Flights";
import { uuid } from "uuidv4";
import PassengerList from "./components/Passenger Details/PassengerListV2";
import SelectedFlight from "./components/Selected Flight/SelectedFlight";
import Baggage from "./Baggage";
import PaymentCard from "./components/Payments Card/PaymentsCard";
import Loader from "../Loader/Loader";
import MySnackbar from "../MySnackBar";
import Footer from "../../components/Flight/components/Home Footer/Footer";
import { getCommision } from "../../helpers/general.helper";
import faresData from "./fares.json";
import { ButtonBase, TextField } from "@mui/material";
import FareSummary from "./components/Fare Summary/FareSummary";
import "./index.css";
import { retrieveFromLocalStorage } from "../Common/Utils";

const useStyles = makeStyles((theme) => ({
  paper: {
    height: 140,
    width: 100,
  },
  control: {
    padding: "2%",
    marginBottom: "2%",
    backgroundColor: "var(--white)",
    [theme.breakpoints.down("sm")]: {
      padding: "4%",
    },
  },
  main: {
    marginTop: "2rem",
    marginBottom: "2rem",
    backgroundColor: "var(--backgroundcolor)",
    minHeight: "100vh",
    maxWidth: "80%",
    margin: "0 auto",
    [theme.breakpoints.down("sm")]: {
      paddingTop: "21%",
    },
  },
}));

let prevPrice = 0;
let prevSearchQuery = "";

function FlightBook(props) {
  const classes = useStyles();
  const journey = useSelector((state) => state.flight.journeyDetails);
  const search = useLocation().search;
  const journeyType = new URLSearchParams(search).get("journeyType");
  const departureDate = new URLSearchParams(search).get("departureDate");
  const arrivalDate = new URLSearchParams(search).get("arrivalDate");
  const defaultAdults = new URLSearchParams(search).get("adults");
  const defaultKids = new URLSearchParams(search).get("kids");
  const defaultInfants = new URLSearchParams(search).get("infants");
  const flightClass = new URLSearchParams(search).get("flightClass");
  const departureAirport = new URLSearchParams(search).get("departureAirport");
  const arrivalAirport = new URLSearchParams(search).get("arrivalAirport");
  // const {
  //   journeyType,
  //   departureDate,
  //   arrivalDate,
  //   departureAirport,
  //   arrivalAirport,
  //   adults: defaultAdults,
  //   kids: defaultKids,
  //   infants: defaultInfants,
  // } = journey;
  const [adults, setAdults] = useState(defaultAdults);
  const [kids, setKids] = useState(defaultKids);
  const [infants, setInfants] = useState(defaultInfants);
  //const flightClass = useSelector((state) => retrieveFromLocalStorage(state, "selectedFlight").fare_category);
  const session_id = uuid();

  const [flight, setFlight] = useState(null);
  const selectedCurrency = useSelector((state) => state.flight.currency);
  const [bnum, setBnum] = useState(0);
  const [loading, setLoading] = useState(false);
  const [price, setPrice] = useState(0);
  const [canBook, setCanBook] = useState(false);
  const [baggagePrice, setBaggagePrice] = useState(0);
  const [submitLoader, setSubmitLoader] = useState(false);
  const [showSnackBar, setShowSnackBar] = useState({
    show: true,
    message: "",
    type: "",
  });

  const { orderId } = useParams();

  const dispatch = useDispatch();

  useEffect(() => {
    if (selectedCurrency) fetchData();
  }, [selectedCurrency]);

  useEffect(() => {
    document.body.style.overflow = "visible";
   },[])

  useEffect(() => {
    if (props.passengers && props.passengers.length) {
      let _adults = 0,
        _kids = 0,
        _infants = 0;
      for (let pass of props.passengers) {
        if (pass.category == "adult") _adults++;
        if (pass.category == "child") _kids++;
        if (pass.category == "infant") _infants++;
      }

      setAdults(_adults);
      setKids(_kids);
      setInfants(_infants);
      fetchData(_adults, _kids, _infants);
      if (
        flight &&
        flight.conversion &&
        flight.conversion.amount &&
        flight.total
      ) {
        let totalBaggagePrice = 0;
        for (let pass of props.passengers) {
          if (
            pass.baggage &&
            pass.baggage.checkedBaggage &&
            pass.baggage.checkedBaggage.price
          ) {
            totalBaggagePrice +=
              (flight.conversion.amount / flight.total) *
              pass.baggage.checkedBaggage.price.amount;
          }
          if (
            pass.baggage &&
            pass.baggage.cabinBaggage &&
            pass.baggage.cabinBaggage.price
          ) {
            totalBaggagePrice +=
              (flight.conversion.amount / flight.total) *
              pass.baggage.cabinBaggage.price.amount;
          }
        }
        setBaggagePrice(totalBaggagePrice);
      }
    }
  }, [props.passengers]);

  useEffect(() => {
    if (props.auth) {
      props.getUserDetails();
    }
    if (props.auth && localStorage.getItem("userLoginType") == "vendor") {
      props.getVendorDetails();
    }
  }, [props.auth]);

  useEffect(() => {
    if (props.vendorCurrency)
      dispatch({ type: "SET_CURRENCY", currency: props.vendorCurrency });
    else dispatch({ type: "SET_CURRENCY", currency: props.currency });
  }, [props.vendorCurrency, props.currency]);

  function setSelectedFlight(flight) {
    dispatch({
      type: "SELECTED_FLIGHT",
      flight,
    });
  }

  const fetchData = async (_adults, _kids, _infants) => {
    setLoading(true);

    if (orderId && selectedCurrency) {
      let queryParam = `/flights/check-flight?booking_token=${orderId}&adults=${
        _adults ? _adults : adults
      }&children=${_kids ? _kids : kids}&infants=${
        _infants ? _infants : infants
      }&visitor_uniqid=${session_id}&bnum=${bnum}`;
      if (selectedCurrency) {
        queryParam += `&currency=${selectedCurrency}`;
      }
      let response = await axios.get(queryParam);
      if (response && response.data && response.data.data) {
        let d = response.data.data;
        let slices = [];
        if (journeyType !== "Return") {
          let slice = {
            origin: departureAirport,
            destination: arrivalAirport,
            duration: d.duration?.departure,
            airline: {},
          };
          let segments = [];
          if (d.flights) {
            d.flights.map((route) => {
              route.flyFrom = route.src;
              route.cityFrom = route.src_name;
              route.flyTo = route.dst;
              route.cityTo = route.dst_name;
              route.operating_carrier = route.airline.code;
              segments.push(route);
              slice.airline[route.airline.code] = 1;
            });
          }
          slice.segments = segments;
          slices.push(slice);
        } else {
          let segments = [];
          let slice = {
            origin: departureAirport,
            destination: arrivalAirport,
            duration: d.duration?.departure,
            airline: {},
          };
          d.flights.map((route) => {
            route.flyFrom = route.src;
            route.cityFrom = route.src_name;
            route.flyTo = route.dst;
            route.cityTo = route.dst_name;
            route.operating_carrier = route.airline.code;
            segments.push(route);
            slice.airline[route.airline.code] = 1;
            if (route.flyTo === arrivalAirport) {
              slice.segments = [...segments];
              slices.push({ ...slice });
              segments = [];
              slice = {
                destination: departureAirport,
                origin: arrivalAirport,
                duration: d.duration?.return,
                airline: {},
              };
            }
          });
          slice.segments = [...segments];
          slices.push({ ...slice });
        }
        d.slices = slices;
        d.price = Math.round(d?.conversion?.amount)
        setFlight(d)
        dispatch({
          type: "SELECTED_FLIGHT",
          flight: d,
        });
        setPrice(d?.conversion?.amount);
      }
      setLoading(false);
    }
  };

  const getAirportCode = async (code) => {
    let response = await axios.get(`flights/airports?query=${code}`);
    if (response && response.data && response.data.data) {
    }
  };

  const continuosfetchData = async () => {
    if (orderId && selectedCurrency) {
      let queryParam = `/flights/check-flight?booking_token=${orderId}&adults=${adults}&children=${kids}&infants=${infants}&visitor_uniqid=${session_id}&bnum=${bnum}`;
      if (selectedCurrency) {
        queryParam += `&currency=${selectedCurrency}`;
      }

      let response = await axios.get(queryParam);
      if (response && response.data && response.data.data) {
        let d = response.data.data;
        if (
          d.flights_checked == true &&
          d.flights_invalid == false &&
          d.price_change == false
        ) {
          setCanBook(true);
        }

        let amount = d?.conversion?.amount;
        if (
          prevPrice != 0 &&
          amount != 0 &&
          prevPrice != amount &&
          prevSearchQuery == queryParam
        ) {
          let baggage_price = (
            getCommision(price, props.commissionType, props.commissionValue) +
            getCommision(
              price,
              props.adminCommissionType,
              props.adminCommissionValue
            ) +
            baggagePrice +
            getCommision(
              baggagePrice,
              props.commissionType,
              props.commissionValue
            ) +
            getCommision(
              baggagePrice,
              props.adminCommissionType,
              props.adminCommissionValue
            )
          ).toFixed(2);
          Swal.fire({
            position: "center",

            // icon: "warning",
            html: `<div style="background-color:var(--backgroundcolor)">
        <div style="display:inline-block;width:20%">
        <img src="${FlightIcon}" style="width:100%"/>
          </div>
        <div style="display:inline-block;width:78%;text-align:left">
        <div style="padding:10px">
        <p style="margin:0px;margin-top:10px;font-size:25px;color:orange;font-weight:bold;color:var(--darker)">Do you want to continue?</p>
        <p style="font-size:20px;color:var(--darker)">Prices are changed from ${selectedCurrency} ${
              prevPrice + baggage_price
            } to ${selectedCurrency} ${price + baggage_price}.</p>
    
        </div>
        </div>`,

            showConfirmButton: true,
            showCancelButton: true,
          }).then((result) => {
            if (result.isConfirmed) {
              setCanBook(false);
            }
          });
        }
        prevPrice = amount;
        prevSearchQuery = queryParam;
        setPrice(amount);
      }
    }
  };

  // let interval;
  // useEffect(() => {
  //   if (interval) {
  //     clearInterval(interval);
  //   }
  //   interval = setInterval(() => continuosfetchData(), 10000);
  //   return () => {
  //     if (interval) {
  //       clearInterval(interval);
  //     }
  //   };
  // }, [adults, kids, infants, selectedCurrency]);

  const proceedToPayment = async (token) => {
    const { saveBooking, listValid, email, phone } = props;
    const { passengers } = props;

    const exist_Adult = passengers.find((pass) => pass.category == "adult");

    if (!listValid) {
      setShowSnackBar({
        show: true,
        message: "Please fill the mandatory fields in the Passenger list",
        type: "error",
      });
      return;
    }
    if (!exist_Adult) {
      setShowSnackBar({
        show: true,
        message: "Add atleast one adult passenger to continue",
        type: "error",
      });
      return;
    }

    let data = {
      lang: "en",
      currency: selectedCurrency,
      booking_token: orderId,
      session_id: session_id,
      // bags: adults.length,
    };

    let baggage = [];

    data.passengers = passengers.map((item, i) => {
      if (item.baggage && item.baggage.checkedBaggage) {
        let checkExistHoldBagIndex =
          baggage &&
          baggage.findIndex((bag) => bag.combination.category == "hold_bag");
        if (checkExistHoldBagIndex != -1) {
          baggage[checkExistHoldBagIndex].passengers.push(i);
        } else {
          baggage.push({
            combination: item.baggage.checkedBaggage,
            passengers: [i],
          });
        }
      }

      if (item.baggage && item.baggage.cabinBaggage) {
        let checkExistHandBagIndex =
          baggage &&
          baggage.findIndex((bag) => bag.combination.category == "hand_bag");
        if (checkExistHandBagIndex != -1) {
          baggage[checkExistHandBagIndex].passengers.push(i);
        } else {
          baggage.push({
            combination: item.baggage.cabinBaggage,
            passengers: [i],
          });
        }
      }
      delete item.id;
      delete item.baggage;
      item.cardno = item.passport ? item.passport : "NOTREQUIRED";
      return item;
    });
    data.baggage = baggage;

    let check_booking_data = {
      booking_token: orderId,
      adults: passengers.length,
      children: kids,
      visitor_uniqid: session_id,
      journey_type: journeyType,
      currency: selectedCurrency,
    };

    setSubmitLoader(true);
    saveBooking(
      {
        data: data,
        check_data: check_booking_data,
        useWallet: token.id === "NOT_REQUIRED",
        payment_token: token.id,
      },
      session_id
    )
      .then((res) => {
        setSubmitLoader(false);
        setShowSnackBar({
          show: true,
          message: "Flight booked successfully!",
          type: "success",
        });
        if (localStorage.getItem("userLoginType") == "vendor") {
          props.history.push("/vendor/orders");
        } else {
          props.history.push("/flights");
        }
      })
      .catch((err) => {
        setShowSnackBar({
          show: true,
          message: "Something went wrong!",
          type: "error",
        });
        setSubmitLoader(false);
      });
  };

  const handleBack = () => {
    props.history.goBack();
  };
  return (
    <>
      <div className={`${classes.main} main-container`}>
        <Grid
          container
          className="third-container"
          justifyContent="space-between"
        >
          <Grid xs="12" sm="12" md="9" className="flight-booking">
            <SelectedFlight flight={flight} loading={loading} />
            <PassengerList
              document_options={flight?.document_options}
              childs={kids}
              adults={adults}
              infants={infants}
              selectedCurrency={selectedCurrency}
            />
            <PaymentCard
              onSuccess={proceedToPayment}
              adminCommission={{
                type: props.adminCommissionType,
                value: props.adminCommissionValue,
              }}
              flight={flight}
              price={
                price.toFixed(2)}
              canBook={canBook}
            />
            <Loader show={submitLoader} />
          </Grid>
          <FareSummary
            adminCommission={{
              type: props.adminCommissionType,
              value: props.adminCommissionValue,
            }}
            flight={flight}
          />
        </Grid>

        <MySnackbar
          show={showSnackBar.show}
          onClose={() =>
            setShowSnackBar({ show: false, message: "", type: "info" })
          }
          message={showSnackBar.message}
          type={showSnackBar.type}
        />
      </div>
      <Footer />
    </>
  );
}

const mapStateWithProps = (state) => {
  let commissionType = "";
  let commissionValue = 0;
  let vendorCurrency;
  if (state.vendor && state.vendor.vendorDetail) {
    commissionType = state.vendor.vendorDetail.commissionType;
    commissionValue = state.vendor.vendorDetail.commissionValue;
    vendorCurrency = state.vendor.vendorDetail.currency;
  }
  let adminCommissionType = "Fixed";
  let adminCommissionValue = 0;
  if (
    state.admin &&
    state.admin.commission &&
    state.admin.commission.commissionType
  ) {
    adminCommissionType = state.admin.commission.commissionType;
    adminCommissionValue = state.admin.commission.commissionValue;
  }
  return {
    auth: state.user.auth,
    userDetails: state.user.userDetails,
    passengers: state.flight.passengers,
    old_passengers: state.flight.old_pass,
    email: state.flight.email,
    phone: state.flight.phone,
    currency: state.flight.currency ? state.flight.currency : "",
    listValid: state.flight.passengerListValid,
    commissionType: commissionType,
    commissionValue: commissionValue,
    vendorCurrency,
    adminCommissionType,
    adminCommissionValue,
  };
};

const mapDispatchToProps = (dispatch) => ({
  toggleSignUp: (isOpen) => dispatch(toggleSignUp(isOpen)),
  setSelectedFlight: (flight) => dispatch({ type: "SELECTED_FLIGHT", flight }),
  getUserDetails: () => dispatch(getUserDetails()),
  getVendorDetails: () => dispatch(getVendorDetails()),
  saveBooking: (data, session_id) => dispatch(saveBooking(data, session_id)),
});

export default connect(mapStateWithProps, mapDispatchToProps)(FlightBook);
